import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

// Session times are stored as real UTC instants, but GymLive is Ireland-based so
// every wall-clock the admin sees/enters is club-local `Europe/Dublin` time (DST-aware:
// GMT in winter, IST/UTC+1 in summer). These helpers convert between the picker's
// wall-clock and the stored UTC instant, so a session shows the same Irish time here,
// in club-onboarding, and to members — regardless of the viewer's browser timezone.
const CLUB_TZ = "Europe/Dublin";

// Serialize a picker's wall-clock (read in Europe/Dublin) as the UTC instant it
// denotes, so 09:00 picked in Dublin stores as 08:00Z during summer time. The
// picker's displayed components are taken verbatim (browser tz is irrelevant).
export function wallClockISO(d: dayjs.Dayjs): string {
  return dayjs.tz(d.format("YYYY-MM-DDTHH:mm:ss"), CLUB_TZ).toISOString();
}

// Parse a stored UTC instant into a dayjs whose LOCAL components equal the Dublin
// wall-clock, so an Ant DatePicker (which renders in the browser's local tz)
// pre-fills showing the Irish time, not the browser-shifted instant.
export function fromWallClock(iso: string): dayjs.Dayjs {
  return dayjs(dayjs.utc(iso).tz(CLUB_TZ).format("YYYY-MM-DDTHH:mm:ss"));
}

// Display helpers — format the stored UTC instant in Europe/Dublin.
export function fmtWallDate(iso: string): string {
  return dayjs.utc(iso).tz(CLUB_TZ).format("ddd, DD MMM YYYY");
}

export function fmtWallTime(iso: string): string {
  return dayjs.utc(iso).tz(CLUB_TZ).format("HH:mm");
}
